import { Component } from '@angular/core';
import { LeaderboardType } from '@fgb/core';

@Component({
  selector: 'fgb-quiz-leaderboard-page',
  templateUrl: './quiz-leaderboard-page.component.html',
  styleUrl: './quiz-leaderboard-page.component.scss',
})
export class QuizLeaderboardPageComponent {
  LeaderboardType: LeaderboardType = LeaderboardType.TriviaPoints;
}
